import Vue from 'vue'
import {Message, Aside, Button, Card, Checkbox, Col, Container, DatePicker, Form, FormItem, Input, InputNumber, Main, Menu, MenuItem, Radio, Row, Table, TableColumn, TabPane, Tabs, Pagination, Select, Option, Link, Slider, CheckboxGroup, RadioButton, RadioGroup, Dialog, Tag, Image,Cascader } from 'element-ui'

Vue.use(Cascader)
Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Card)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(InputNumber)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(DatePicker)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Option)
Vue.use(Link)
Vue.use(Slider)
Vue.use(Dialog)
Vue.use(Tag)
Vue.use(Image)


Vue.prototype.$message = Message;

// 2.1 ok
// 2.2 ok
// 2.3 ok
// 2.4 not ok
// 2.1 ok
// 4 修改密码 ok
// 5 消息通知 ok 里面没数据
// 6 not ok
// 2.1 ok
